import { gql } from "graphql-request";

export const FETCH_ACTIVATION_CREDITS = gql`
  query FetchActivationCredits($params: QueryParamsInput!) {
    data: fetchActivationCredits(params: $params) {
      alert {
        type
        message
      }
      pagination {
        currentPage
        pageItems
        totalItems
        totalPages
        totalFilteredItems
      }
      payload
    }
  }
`;

export const CREATE_ACTIVATION_CREDIT = gql`
  mutation CreateActivationCredit(
    $createActivationCreditInput: CreateActivationCreditInput!
  ) {
    data: createActivationCredit(
      createActivationCreditInput: $createActivationCreditInput
    ) {
      alert {
        type
        message
      }
      payload
    }
  }
`;

export const DELETE_ACTIVATION_CREDIT = gql`
  mutation DeleteActivationCredit($activationCreditId: String!) {
    data: deleteActivationCredit(activationCreditId: $activationCreditId) {
      alert {
        type
        message
      }
      payload
    }
  }
`;

export const FETCH_MONTHY_CREDIT_USAGE = gql`
  query FetchMonthlyCreditUsage {
    data: fetchMonthlyCreditUsage {
      alert {
        type
        message
      }
      payload
    }
  }
`;
